import {
  type DocumentData,
  limit,
  orderBy,
  type QueryConstraint,
  startAfter,
  type Timestamp,
  where,
} from "firebase/firestore";
import { firestoreApi } from "../../core/apis/firestoreApi";
import BaseApi from "../../core/BaseApi";
import {
  type BusinessFeedCommentData,
  BusinessFeedCommentModel,
} from "./BusinessFeedCommentModel";

export default class BusinessFeedCommentsApi extends BaseApi<
  BusinessFeedCommentModel,
  BusinessFeedCommentData
> {
  /* PRIVATE APIS */

  async getFeedCommentsForFeedItem(feedUid: string, startFromTs?: Timestamp) {
    const qs: QueryConstraint[] = [
      where("feedItemUid", "==", feedUid),
      orderBy("ts", "desc"),
      limit(5),
    ];

    if (startFromTs) {
      qs.push(startAfter(startFromTs)); // Fetch comments before this timestamp
    }

    const querySnapshots = await firestoreApi.queryDocuments(this.db, ...qs);

    const models: BusinessFeedCommentModel[] = [];

    querySnapshots.forEach((querySnapshot) => {
      models.push(this.fromFirestore(querySnapshot));
    });
    this.store.load(models);
  }

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}business_feed_comments`;
  }

  get store() {
    return this.stores.businessFeedCommentsStore;
  }

  fromFirestore(res: DocumentData): BusinessFeedCommentModel {
    return new BusinessFeedCommentModel(this.stores, this.api, {
      uid: res.id,
      ...res.data(),
    });
  }
}
